import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a32bc9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "col-6 regist-h" }, "会員情報入力")
], -1))
const _hoisted_2 = { class: "row mt-1" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "姓", -1))
const _hoisted_5 = { class: "error-message" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "require" }, "名", -1))
const _hoisted_8 = { class: "error-message" }
const _hoisted_9 = { class: "row mt-1" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "require" }, "郵便番号", -1))
const _hoisted_12 = { class: "error-message" }
const _hoisted_13 = { class: "row mt-1" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "require" }, "都道府県", -1))
const _hoisted_16 = { class: "error-message" }
const _hoisted_17 = { class: "row mt-1" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "require" }, "市区町村", -1))
const _hoisted_20 = { class: "error-message" }
const _hoisted_21 = { class: "row mt-1" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "require" }, "町名・番地", -1))
const _hoisted_24 = { class: "error-message" }
const _hoisted_25 = { class: "row mt-1" }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "建物", -1))
const _hoisted_28 = { class: "error-message" }
const _hoisted_29 = { class: "row mt-1" }
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "require" }, "電話番号", -1))
const _hoisted_32 = { class: "error-message" }
const _hoisted_33 = { class: "row mt-1" }
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "require" }, "性別", -1))
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-2" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-2",
  style: {"line-height":"50px"}
}, "男性", -1))
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-2",
  style: {"line-height":"50px"}
}, "女性", -1))
const _hoisted_42 = { class: "error-message" }
const _hoisted_43 = { class: "row mt-1" }
const _hoisted_44 = { class: "col-6" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "生年月日", -1))
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "col-3" }
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "col-3" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "require" }, null, -1))
const _hoisted_51 = ["value"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "btn btn-primary"
    }, "次へ")
  ])
], -1))

import {ref, reactive, inject, onMounted, computed, toRefs} from 'vue'
import { useCookies } from "vue3-cookies";
import { DataStore } from 'aws-amplify';
import { useRouter } from 'vue-router';
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { Member } from '@/models';
import Modal from '../../components/Modal.vue'
import { Core as YubinBangoCore } from "yubinbango-core2";

interface Props {
  member: Member;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    member: null
  },
  emits: ['stopLoading'],
  setup(__props: any, { emit }) {

const props = __props as {
  member: Member;
}



const { member } = toRefs(props);



const router = useRouter();
const {cookies} = useCookies();
const api: any = inject('api');

const email = ref();

const formSchema = yup.object({
  familyName: yup.string().required('必須項目です'),
  givenName: yup.string().required('必須項目です'),
  postCode: yup.string().required('必須項目です').matches(/^[0-9]{7}$/i, 'ハイフン無しの7桁の数字を入力してください'),
  pref: yup.string().required('必須項目です'),
  address1: yup.string().required('必須項目です'),
  address2: yup.string(),
  address3: yup.string(),
  tel: yup.string().required('必須項目です').matches(/^[0-9]+$/i, 'ハイフン無しの数字を入力してください'),
  gender: yup.string().required('必須項目です'),
  birthY: yup.string().required('必須項目です').matches(/^[0-9]+$/i, ''),
  birthM: yup.string().required('必須項目です').matches(/^[0-9]+$/i, ''),
  birthD: yup.string().required('必須項目です').matches(/^[0-9]+$/i, ''),
})

const {errors, meta, handleSubmit} = useForm({ validationSchema: formSchema })

const { value: familyName } = useField<string>("familyName");
const { value: givenName } = useField<string>("givenName");
const { value: postCode } = useField<string>("postCode");
const { value: pref } = useField<string>("pref");
const { value: address1 } = useField<string>("address1");
const { value: address2 } = useField<string>("address2");
const { value: address3 } = useField<string>("address3");
const { value: tel } = useField<string>("tel");
const { value: gender } = useField<number>("gender");
const { value: birthY } = useField<string>("birthY");
const { value: birthM } = useField<string>("birthM");
const { value: birthD } = useField<string>("birthD");

const birthYList: number[]  = [];
const birthMList: number[]  = [];
const birthDList: number[]  = [];
var i;
const y = (new Date().getFullYear()) - 18;
for (i=y; i>y-80; i--) {
  birthYList.push(i);
}
for (i=1; i<=12; i++) {
  birthMList.push(i);
}
for (i=1; i<=31; i++) {
  birthDList.push(i);
}


const saveRegistrationForm = async() => {
  const formData = {
    familyName: familyName.value,
    givenName: givenName.value,
    email: email.value,
    birthY: birthY.value,
    birthM: birthM.value,
    birthD: birthD.value,
    gender: gender.value,
    tel: tel.value,
    postCode: postCode.value,
    pref: pref.value,
    address1: address1.value,
    address2: address2.value,
    address3: address3.value, 
  }
  console.log(formData);
  cookies.set('registration_form', JSON.stringify(formData));
}

const submitHandler = handleSubmit(async() => {
  try {
    await saveRegistrationForm();
    router.push('/registration/confirm');
  }
  catch(e) {
    console.log(e);
  }
});

const searchAddress = () => {
  new YubinBangoCore(postCode.value, (value: any) => {
    pref.value = value.region;
    address1.value = value.locality;
    address2.value = value.street;
  });
}

const postCodeC = computed({
  get: () => postCode.value,
  set: (val: string) => {console.log(val);postCode.value = !val ? '' : val.toString().slice(0, 7);}
});

onMounted(async() => {
  const formData: any = cookies.get('registration_form');
  console.log(formData);
  if (formData) {
    familyName.value = formData.familyName;
    givenName.value = formData.givenName;
    email.value = formData.email;
    birthY.value = formData.birthY;
    birthM.value = formData.birthM;
    birthD.value = formData.birthD;
    gender.value = formData.gender;
    tel.value = formData.tel;
    postCode.value = formData.postCode;
    pref.value = formData.pref;
    address1.value = formData.address1;
    address2.value = formData.address2;
    address3.value = formData.address3; 
  }
  else {
    const verifyCode: string = cookies.get('verify_code');

    try {
      const regEmail = await api.verifyRegistrationCode(verifyCode);
      if (!regEmail) {
        router.push('./mail');
      }
      email.value = regEmail.email;
    }
    catch(e) {
      console.log(e);
      router.push('./mail');
    }
  }

  emit('stopLoading');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_unref(submitHandler) && _unref(submitHandler)(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(familyName) ? (familyName).value = $event : null)),
            placeholder: "山田"
          }, null, 512), [
            [_vModelText, _unref(familyName)]
          ]),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(errors).familyName), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(givenName) ? (givenName).value = $event : null)),
            placeholder: "太郎"
          }, null, 512), [
            [_vModelText, _unref(givenName)]
          ]),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(errors).givenName), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(postCodeC) ? (postCodeC).value = $event : null)),
            maxlength: "7",
            onBlur: searchAddress,
            placeholder: "1234567"
          }, null, 544), [
            [_vModelText, _unref(postCodeC)]
          ]),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(errors).postCode), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(pref) ? (pref).value = $event : null))
          }, null, 512), [
            [_vModelText, _unref(pref)]
          ]),
          _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(errors).pref), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(address1) ? (address1).value = $event : null))
          }, null, 512), [
            [_vModelText, _unref(address1)]
          ]),
          _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(errors).address1), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(address2) ? (address2).value = $event : null)),
            placeholder: "◯◯町 1-1"
          }, null, 512), [
            [_vModelText, _unref(address2)]
          ]),
          _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(errors).address2), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(address3) ? (address3).value = $event : null)),
            placeholder: "XXマンション101"
          }, null, 512), [
            [_vModelText, _unref(address3)]
          ]),
          _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(errors).address3), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(tel) ? (tel).value = $event : null)),
            placeholder: "09012345678"
          }, null, 512), [
            [_vModelText, _unref(tel)]
          ]),
          _createElementVNode("p", _hoisted_32, _toDisplayString(_unref(errors).tel), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(gender) ? (gender).value = $event : null)),
                value: "0"
              }, null, 512), [
                [_vModelRadio, _unref(gender)]
              ])
            ]),
            _hoisted_38
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(gender) ? (gender).value = $event : null)),
                value: "1"
              }, null, 512), [
                [_vModelRadio, _unref(gender)]
              ])
            ]),
            _hoisted_41
          ]),
          _createElementVNode("p", _hoisted_42, _toDisplayString(_unref(errors).gender), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(birthY) ? (birthY).value = $event : null))
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(birthYList, (y) => {
              return _createElementVNode("option", {
                key: y,
                value: y
              }, _toDisplayString(y), 9, _hoisted_46)
            }), 64))
          ], 512), [
            [_vModelSelect, _unref(birthY)]
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(birthM) ? (birthM).value = $event : null)),
            class: "mt-3"
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(birthMList, (m) => {
              return _createElementVNode("option", {
                key: m,
                value: m
              }, _toDisplayString(m), 9, _hoisted_48)
            }), 64))
          ], 512), [
            [_vModelSelect, _unref(birthM)]
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(birthD) ? (birthD).value = $event : null)),
            class: "mt-3"
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(birthDList, (d) => {
              return _createElementVNode("option", {
                key: d,
                value: d
              }, _toDisplayString(d), 9, _hoisted_51)
            }), 64))
          ], 512), [
            [_vModelSelect, _unref(birthD)]
          ])
        ])
      ]),
      _hoisted_52
    ], 32)
  ], 64))
}
}

})